import Event from '../../core/Event';

export default class OrderPlaceFailed extends Event {
    public static type = 'OrderPlaceFailed';

    constructor(public readonly status: string) {
        super(OrderPlaceFailed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderPlaceFailed.ts